module.exports = __webpack_public_path__ + "imgs/OneColorado.1a3b59427230a88f15d50aba15db5e0e.png";